require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./eventi-lidea-di-unimmagine-perfetta-riflessioni-intorno-allopera-di-livio-vacchini-19332007.json") })
        }
      }, "path---eventi-lidea-di-unimmagine-perfetta-riflessioni-intorno-allopera-di-livio-vacchini-19332007");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---eventi-lidea-di-unimmagine-perfetta-riflessioni-intorno-allopera-di-livio-vacchini-19332007!./.cache/json/eventi-lidea-di-unimmagine-perfetta-riflessioni-intorno-allopera-di-livio-vacchini-19332007.json
// module id = 658
// module chunks = 231608221292675